export default {"src":"/_next/static/media/lockup_dark.aaba0110.svg","height":256,"width":1283,"blurWidth":0,"blurHeight":0};